<template>
  <q-page padding class="window-height window-width row justify-center items-center">
    <div class="column full-width">

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-4 offset-md-4">
          <q-card dark :bordered="!isMobile" class="q-pa-lg"
                  :class="{ 'shadow-4': !isMobile }">
            <h5 class="text-h5 text-white q-my-md text-center">Checkout Link</h5>
            <div style="white-space:normal !important; word-wrap: break-word; max-width: 500px">
              <p>{{ checkoutLink }} </p>
            </div>
            <p class="text-bold text-body1 text-center text-negative">{{ error }}</p>
            <q-form
              @submit="onSubmit"
              @reset="onReset"
              class="q-gutter-md q-mt-md"
            >
              <q-input
                ref="emailRef"
                dark
                filled
                standout
                color="secondary"
                v-model="email"
                type="email"
                label="Email Address"
                hint="Enter your email"
                lazy-rules
                autofocus
                :rules="fieldEmailRules"
              />

              <q-input
                ref="couponRef"
                dark
                filled
                standout
                color="secondary"
                v-model="coupon"
                type="text"
                label="Discount Coupon"
                hint="Enter valid discount coupon"
                lazy-rules
              />

              <div class="q-mt-md">
                <q-btn label="Retrieve" type="submit" color="secondary" class="full-width" :loading="loading" size="lg"/>
              </div>
            </q-form>
          </q-card>
        </div>
      </div>
    </div>
  </q-page>
</template>
<script>
import { ref } from "vue"
import { useRouter } from "vue-router"
import { loggerFactory } from '../../logger'
import { useUserStore } from '../../stores/user-store'
import { useQuasar } from "quasar"

const logger = loggerFactory("RetrieveCheckoutLinkPage")
export default {
  name: "RetrieveCheckoutLinkPage",
  setup() {
    const $q = useQuasar()
    const isMobile = $q.platform.is.mobile
    const router = useRouter()
    const store = useUserStore()
    const error = ref(null)
    const email = ref(null)
    const coupon = ref(null)
    const emailRef = ref(null)
    const couponRef = ref(null)
    const loading = ref(false)
    const checkoutLink = ref(null)

    const fieldEmailRules = ref([
      val => !!val || "Email is required"
    ])

    const notifyError = (message) => {
      $q.notify({ type: "negative", message: message, timeout: 2500 })
    }

    const onSubmit = () => {
      checkoutLink.value = null
      emailRef.value.validate()

      if(emailRef.value.hasError) {
        notifyError("Please complete all fields before continuing.")
        return
      }

      logger.debug("Retrieve checkout link", email.value, coupon.value)
      const discountCoupon = coupon.value || null
      loading.value = true

      store.retrieveCheckoutLink(email.value, discountCoupon)
        .then((link) => {
          logger.debug('Retrieved checkout link...')
          checkoutLink.value = link
        })
        .catch((err) => {
          error.value = err.message
          notifyError(err.message)
        })
        .finally(() => loading.value = false)
    }

    const onReset = () => {
      checkoutLink.value = null

      email.value = null
      emailRef.value.resetValidation()

      coupon.value = null
      couponRef.value.resetValidation()
    }

    return {
      isMobile,
      error,
      email,
      coupon,
      checkoutLink,
      emailRef,
      couponRef,
      loading,
      fieldEmailRules,
      onSubmit,
      onReset,
    }
  }
}
</script>
<style scoped>
</style>
